/**
 * TODO
 * THIS IS COPIED FROM SKYSLOPE MACHE AND IDEALLY WE COULD JUST UPDATE
 * TO THE LATEST VERSION OF MACHE BUT THIS CODEBASE IS CURRENTLY WAYYYY
 * BEHIND.
 */
import React from 'react';
import type { MenuProps } from '@material-ui/core/Menu';

/**
 * MUI's suggested pattern for handling the open/close state of popups is to
 * store the anchorEl ref inside of a piece of state instead of inside a ref
 * object.
 *
 * This hook makes doing so simpler by providing a click handler to store the
 * ref, a close function, an isOpen boolean, and storing the element in a
 * strongly typed fashion.
 */
export function useAnchorEl() {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const isOpen = Boolean(anchorEl);
  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const close = () => setAnchorEl(null);

  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(e.currentTarget as HTMLButtonElement);
  };

  return {
    /** Pass to the `anchorEl` prop of the popup */
    anchorEl,
    /** Pass to the `open` prop of the popup */
    isOpen,
    /** Pass to the `onClose` handler of the popup */
    close,
    /** Pass to the `onClick` handler of the button that should open the popup */
    handleClick,
    /**
     * Convenience object for spreading props over a `<Menu>` if you don't
     * want to pass them all individually every time.
     */
    menuProps: {
      open: isOpen,
      onClose: close,
      onClick: close,
      anchorEl: anchorEl,
    } as AnchorElProps,
  };
}

export type AnchorElProps = Pick<MenuProps, 'open' | 'onClose' | 'onClick' | 'anchorEl'>;
